import React from 'react'
import './Style/Info.css'
function CompanyInfo({data}) {
  return <div className='company-info'>
        <div className='info'>
            <p> {data.companyInfo.companyName} </p>
            <p> {data.companyInfo.streetAddress} </p>
            <p> {data.companyInfo.city} </p>
        </div>
        <h1 className=''> INVOICE </h1>
  </div>
}

export default CompanyInfo